var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-form-item",
    {
      attrs: {
        label: _vm.label || _vm.$t("pc_ulcd_lbl_attachmentfile"),
        prop: "files",
      },
    },
    [
      _c(
        "yxtbiz-upload",
        {
          ref: "bizUpload",
          attrs: {
            "config-key": "AttachConfigKey",
            "module-name": _vm.appCode,
            "app-code": _vm.appCode,
            "function-name": _vm.appCode,
            filters: _vm.filterType,
            "on-ready": _vm.onReady,
            "before-upload": _vm.beforeUpload,
            "on-progress": _vm.onProgress,
            "on-uploaded": _vm.onUploaded,
            "on-error": _vm.onError,
            "on-complete": _vm.onComplete,
            disabled: _vm.disabled,
            "files-added": _vm.fileAdded,
          },
        },
        [
          _vm.buttonType
            ? _c(
                "yxt-button",
                {
                  attrs: {
                    icon: "yxt-icon-upload2",
                    plain: "",
                    disabled: _vm.disabled,
                    type: _vm.buttonType,
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_ulcd_btn_uploadfile")))]
              )
            : _c(
                "yxt-button",
                {
                  attrs: {
                    icon: "yxt-icon-upload2",
                    plain: "",
                    disabled: _vm.disabled,
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_ulcd_btn_uploadfile")))]
              ),
        ],
        1
      ),
      _vm.$slots.toolTip
        ? _vm._t("toolTip", function () {
            return [
              _c("div", { staticClass: "c-bf" }, [
                _vm._v(_vm._s(_vm.$t("pc_ulcd_msg_filemessage"))),
              ]),
            ]
          })
        : _c("div", { staticClass: "c-bf" }, [
            _vm._v(_vm._s(_vm.$t("pc_ulcd_msg_filemessage"))),
          ]),
      _c(
        "ul",
        _vm._l(_vm.files, function (file) {
          return _c(
            "li",
            { key: file.fileId, staticClass: "pv12 border-l2b" },
            [
              _c(
                "span",
                {
                  staticClass: "d-in-block has-del-icon v-mid nowrap ellipsis",
                },
                [_vm._v(_vm._s(file.name))]
              ),
              _c("ulcd-svg", {
                staticClass: "v-mid hand c-bf v-mid ml16 hover-primary-6",
                attrs: {
                  back: "",
                  name: "close",
                  width: "20px",
                  height: "20px",
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.removeFile(file)
                  },
                },
              }),
              file.percentage !== 100
                ? _c("yxt-progress", {
                    staticClass: "pa pa-l-b fit-w",
                    attrs: { percentage: file.percentage },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }